import axiosInstance from "../models/axiosInstance";

const getAllAnalystData = (data) => {
  let body = {
    data: data
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/getAllAnalyst`,
    body: body
  };
};
const getAssessmentData = (data) => {
  let body = {
    data: data
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/getAssessmentData`,
    body: body
  };
};
const createIssueRequest = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/createIssue`,
    body: data,
  };
};
const updateDashboardGraphFlag = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/dashboard/updateDashboardGraphFlag`,
    body: data,
  };
};
const getThirdPartyCriticalityRatingCount = (countryCode) => {
  let data = {
    countryCode: countryCode
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getThirdPartyCriticalityRatingCount`,
    body: data
  };
};
const getAllDashboardGraphsList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getAllDashboardGraphsList`,
  };
};
const getTopTenVendorsByRiskRating = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getTopTenVendorsByRiskRating`,
  };
};
const getIssueAgingReport = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getIssueAgingReport`,
  };
};
const getIssuesbyPriorityChart = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getIssuesbyPriorityChart`,
  };
};
const getRatingbyRisksChart = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getRatingbyRisksChart`,
  };
};
const getPeriodicAssessmentChart = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getPeriodicAssessmentChart`,
  };
};
const getSelectedGraphs = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getSelectedGraphs`,
  };
};
const getWidgetsData = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getWidgetsData`,
    body: data
  };
};
const getRiskAgingChart = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getRiskAgingChart`,
    body: data
  };
};
const getIssueAgingChart = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssueAgingChart`,
    body: data
  };
};
const getIssuesbyRating = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssuesbyRating`
  };
};
const getOverallRiskScore = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getOverallRiskScore`,
    body: data
  };
};
const getIssuesbyRatingDrill = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getIssuesbyRatingDrill`,
  };
};
const getThirdPartyCriticalityRating = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getThirdPartyCriticalityRating`,
  };
};
const getOverallRiskTrend = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getOverallRiskTrend`,
  };
};
const getRegionalRiskScore = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getRegionalRiskScore`,
  };
};
const getPriorityLevelData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getPriorityLevelData`,
  };
};
const getAssessmentTableList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getAssessmentTableList`,
  };
};
const getActiveRisksCount = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getActiveRisksCount`,
  };
};
const getActiveIssuesCount = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getActiveIssuesCount`,
  };
};
const getOverdueAssessmentCount = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getOverdueAssessmentCount`,
  };
};
const getActiveAssessmentCount = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getActiveAssessmentCount`,
  };
};
const RiskOverallTrendDrilldown = (ID, time, country) => {
  let data = {
    ID: ID,
    timeStamp: time,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/RiskOverallTrendDrilldown`,
    body: data
  };
};
const CriticalRatingDrilldown = (ID, country) => {
  let data = {
    ID: ID,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/CriticalRatingDrilldown`,
    body: data
  };
};
const issueByRatingDrilldown = (ID) => {
  let data = {
    rating: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/issueByRatingDrilldown`,
    body: data
  };
};
const RatingByRiskDrilldown = (month, value, country) => {
  let data = {
    month: month,
    values: value,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/ratingByRiskDrilldown`,
    body: data
  };
};
const UpcomingAssessmentsDrilldown = (month, country) => {
  let data = {
    month: month,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/upcomingAssessmentDrilldown`,
    body: data
  };
};
const issueAgingDrilldown = (month, country) => {
  let data = {
    month: month,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/IssueagingDrilldown`,
    body: data
  };
};
const riskAgingDrilldown = (month, country) => {
  let data = {
    month: month,
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/RiskagingDrilldown`,
    body: data
  };
};
const UpcomingAssessmentsChartCount = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/UpcomingAssessmentsChartCount`,
    body: data
  };
};
const RatingbyRiskchartCount = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getRatingbyRiskchartCount`,
    body: data
  };
};
const getOverAllRiskTrendsCount = (country) => {
  let data = {
    country: country
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getOverAllRiskTrendsCount`,
    body: data
  };
};
const getOptionalWidgetsData = (userID) => {
  let data = {
    userID: userID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getOptionalWidgets`,
    body: data
  };
};
const dragAndDropInsert = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/dragAndDropInsert`,
    body: data,
  };
};
const getVendorResponseCountAPI = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getVendorResponseCountAPI`,
  };
};

const vendorResponseDrilldownAPI = (ID) => {
  let data = {
    ID: ID,
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/vendorResponseDrilldownAPI`,
    body: data
  };
};
const IssueManagementFollowUpDrilldownDataAPI = (ID,status) => {
  let data = {
    ID: ID,
    status:status
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/IssueManagementFollowUpDrilldownDataAPI`,
    body: data
  };
};
const getVendorHighRiskModalDrillDownData = (service,risk) => {
  let data = {
    service: service,
    risk:risk
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getVendorHighRiskModalDrillDownDataAPI`,
    body: data
  };
};

const getClosureStatusTrendsCount = () => {

  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getClosureStatusTrendsCount`,
  };
};

const getIssueClosureTrendDrillDownData = (status,date) => {
  let data = {
    status: status,
    date:date
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssueClosureTrendDrillDownData`,
    body: data
  };
};

const getIssuesOpenClose = () => {

  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getIssuesOpenClose`,
  };
};

const getIssuesCloseOpenAPIData = (status) => {
  let data = {
    status: status  
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssuesCloseOpenAPIData`,
    body: data
  };
};

const AssessmentbyRatingDrillDownAPI = (rating,category) => {
  let data = {
    rating: rating,
    category:category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getAssessmentbyRatingDrillDownAPI`,
    body: data
  };
};

const APIServiceExtended = {
  getAllAnalystData,
  getAllDashboardGraphsList,
  getAssessmentData,
  getIssueAgingReport,
  getIssuesbyPriorityChart,
  getPeriodicAssessmentChart,
  getRatingbyRisksChart,
  getSelectedGraphs,
  getThirdPartyCriticalityRatingCount,
  getTopTenVendorsByRiskRating,
  createIssueRequest,
  updateDashboardGraphFlag,
  getActiveAssessmentCount,
  getActiveIssuesCount,
  getActiveRisksCount,
  getAssessmentTableList,
  getIssueAgingChart,
  getIssuesbyRating,
  getIssuesbyRatingDrill,
  getOverallRiskScore,
  getOverallRiskTrend,
  getOverdueAssessmentCount,
  getPriorityLevelData,
  getRegionalRiskScore,
  getRiskAgingChart,
  getWidgetsData,
  getThirdPartyCriticalityRating,
  getOptionalWidgetsData,
  getOverAllRiskTrendsCount,
  RiskOverallTrendDrilldown,
  riskAgingDrilldown,
  UpcomingAssessmentsChartCount,
  UpcomingAssessmentsDrilldown,
  CriticalRatingDrilldown,
  RatingByRiskDrilldown,
  issueByRatingDrilldown,
  RatingbyRiskchartCount,
  issueAgingDrilldown,
  dragAndDropInsert,
  getVendorResponseCountAPI,
  vendorResponseDrilldownAPI,
  IssueManagementFollowUpDrilldownDataAPI,
  getVendorHighRiskModalDrillDownData,
  getClosureStatusTrendsCount,
  getIssueClosureTrendDrillDownData,
  getIssuesOpenClose,
  getIssuesCloseOpenAPIData,
  AssessmentbyRatingDrillDownAPI
};

export default APIServiceExtended;
